import React, { Component } from 'react';
import { Button, TextField, Dialog, DialogContent, DialogContentText, DialogActions, Container, Grid, Card } from '@material-ui/core/';
import { LoginAction, ForgotPasswordAction, LoginOnChange, LoginSetErrors } from '../actions';
import { connect } from 'react-redux';
import OverLoader from './common/loader';

class Login extends Component {

  state = {
    username: '',
    password: '',
    isForgotPassword: false,
    forgotEmail: '',
    forgotError: false
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.listener);
  }
  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.listener);
  }

  listener = event => {
    const { isForgotPassword } = this.state
    if ((event.code === "Enter" || event.code === "NumpadEnter") && !isForgotPassword) {
      this.handleSubmit()
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { forgot_succes, forgot_error } = this.props
    if (nextProps.forgot_success !== forgot_succes) {
      this.setState({ isForgotPassword: false })
    }
    if (nextProps.forgot_error !== forgot_error)
      this.setState({ forgotError: true, isForgotPassword: true })
  }

  handleSubmit = () => {
    const { username, password } = this.state
    if (!username)
      this.props.LoginSetErrors("username", true);
    if (!password)
      this.props.LoginSetErrors("password", true);
    if (username !== "" && password !== "") {
      this.props.LoginAction(username, password)
    }
  }
  render() {
    const { forgot_error, forgot_success_message } = this.props
    return (
      <Container>
        {this.props.loading && <OverLoader />}
        <Grid className="text-center">
          <br />
          <br />
          <h5>Willkommen beim Lipro-System 4.0</h5>
          <h3>Lischke Consulting GmbH</h3>
          <br />
          <Card className="p-40">
            <div className="flex-center">

              <div className="w-150">Benutzername</div>

              <TextField error={this.props.login_errors.username} id="username"
                required className="w-150" label="" onChange={(e) => {
                  this.props.LoginSetErrors("username", false);
                  this.setState({ username: e.target.value })
                }} />

            </div>

            <br />

            <div className="flex-center">

              <div className="w-150">Kennwort</div>
              <TextField error={this.props.login_errors.password} type="password" id="password"
                required className="w-150" label="" onChange={(e) => {
                  this.props.LoginSetErrors("password", false);

                  this.setState({ password: e.target.value })
                }} />

            </div>
            <br />

            <div className="h-50">
              {
                this.props.login_server_error &&
                <small className="text-red"> {this.props.http_error.message}</small>
              }
            </div>
          </Card>

          <br />
          {forgot_success_message && <div>
            <span style={{ color: "#4caf50" }}>{forgot_success_message}</span>
          </div>}
          <br />

          <Button type="submit" onClick={this.handleSubmit} variant="outlined" color="primary" className="m-10">Anmelden</Button>

          <Button variant="outlined" onClick={() => this.setState({ isForgotPassword: true })} className="m-10">Zugangsdaten vergessen</Button>

        </Grid>
        <Dialog
          open={this.state.isForgotPassword}
        >
          <DialogContent>
            <DialogContentText style={{ color: "rgba(0, 0, 0, 0.87)" }}>
              Haben Sie Ihren Benutzernamen und/oder Ihr Kennwort vergessen?
              <br />
              Wir senden Ihnen eine Mail.
              </DialogContentText>
            <div className="inner-field inner-field-1">
              <label style={{ fontSize: "16px", fontWeight: "400" }}>Ihre Mailadresse</label>
              <TextField
                autoFocus
                style={{ maxWidth: 300 }}
                size="small"
                value={this.state.forgotEmail}
                helperText={this.state.forgotError === true ? forgot_error : ''} error={this.state.forgotError === true ? true : false}
                className="innerInput" onChange={(e) => { this.setState({ forgotEmail: e.target.value, forgotError: false }) }} variant="outlined" />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.props.ForgotPasswordAction(this.state.forgotEmail)} size="small" variant="outlined" color="primary" autoFocus>
              Senden
              </Button>
            <Button onClick={() => this.setState({ isForgotPassword: false, forgotError: false, forgotEmail: "" })} size="small" variant="outlined" color="secondary">
              Zurück
              </Button>
          </DialogActions>
        </Dialog>
      </Container>
    )

  }
}

const mapStateToProps = state => {
  const { user, forgot_success, forgot_success_message, forgot_error, login_form, login_errors, login_server_error, http_error, loading } = state.login;
  return {
    user,
    forgot_success,
    login_form,
    login_errors,
    login_server_error,
    http_error,
    forgot_error,
    forgot_success_message,
    loading
  }
}

export default connect(
  mapStateToProps,
  {
    LoginAction,
    LoginOnChange,
    LoginSetErrors,
    ForgotPasswordAction
  }
)(Login)